import React from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { CaptionLG, CaptionSM } from '@/atoms/Text'
import { slugs } from '@/constants/slugs'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawaySchedule } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawaySchedule'
import { CountdownToMidnight } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/GiveawayBanners/CountdownToMidnight'
import DavidStyledText from '../../DavidStyledText'

const foregroundImage = { url: '/v1762291592/david/image', width: 1676, height: 592 }
const accentColor = '#57457A'

interface Props {
  className?: string
}

export const DavidGiveawayBanner: React.FC<Props> = ({ className }) => {
  const { t } = useTranslate('tickets')
  const { isActive, dailyBonusEntries, refetch } = useGiveawaySchedule(slugs.david)

  if (!isActive) return null

  return (
    <div className={classNames(className)}>
      <div className="relative z-[39] rounded-xl @container">
        <div className="w-full overflow-hidden rounded-xl" style={{ backgroundColor: accentColor }}>
          <div
            className="absolute inset-0 z-20 rounded-xl"
            style={{ background: `linear-gradient(to right, ${accentColor} 50%, transparent)` }}
          />
          <div className="absolute inset-y-0 right-0 z-10 overflow-hidden rounded-r-xl">
            <Image
              src={foregroundImage.url}
              className="rounded-r-xl opacity-20 @3xl:opacity-100"
              height={190}
              width={(foregroundImage.width / foregroundImage.height) * 190}
              alt="David Giveaway Foreground"
            />
          </div>
          <div className="relative z-30 flex flex-col flex-nowrap p-3 @lg:p-4 @2xl:px-6 @2xl:py-4">
            <DavidStyledText
              color="white"
              className="whitespace-nowrap text-[22px] @lg:text-[28px]"
              face="royal-loudes-rough"
            >
              {t('watchDavidInTheatersAnd', 'watch David in theaters and')}
            </DavidStyledText>
            <DavidStyledText
              color="white"
              className="whitespace-nowrap text-[48px] @lg:text-[74px] @2xl:text-[90px]"
              face="royal-loudes-rough"
            >
              {t('enterToWin60KCash', 'enter to win a $60K')}
            </DavidStyledText>
            <DavidStyledText color="white" className="whitespace-nowrap text-[22px] @lg:text-[28px]">
              {t('DavidGrandPrize', 'David Christmas Tour Giveaway')}
            </DavidStyledText>
            <div className="mt-2 flex items-center gap-1">
              <CaptionSM color="white" weight="semibold" className="whitespace-nowrap @lg:hidden">
                {t('entriesTodayEndsIn', 'Get {{bonusEntries}} Entries Today! Ends in:', {
                  bonusEntries: dailyBonusEntries,
                })}
              </CaptionSM>
              <CaptionLG color="white" className="hidden @lg:block">
                {t('getBonusEntriesTodayEndsIn', 'Get {{bonusEntries}} Bonus Entries Today! Ends in:', {
                  bonusEntries: dailyBonusEntries,
                })}
              </CaptionLG>

              <CountdownToMidnight
                onCountdownEnd={refetch}
                textColorClass="text-white"
                numberClassName={
                  '@xs/text:text-[12px] @sm/text:text-xs @md/text:text-xs @lg/text:text-xs @2xl/text:text-sm @xs/text:!py-0.5 @xs/text:!px-1 @2xl/text:!py-[2px] @2xl/text:!px-[5px] @lg/text:leading-[14px] @2xl/text:leading-[18px] @3xl/text:leading-[18px] @3xl/text:text-base @5xl/text:text-xl'
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
